export const Logo = ({ className = "", showText = true, size = "h-8" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <img src="/logo-mimis.png" alt="Logo MIMIS - Mr & Ms" className={`${size} w-auto select-none`} draggable="false" />
    {showText && (
      <span className="font-display text-[1.35rem] font-extrabold leading-none tracking-tight text-[#111111]">MIMIS</span>
    )}
  </span>
);
